import { useTranslation } from '@rhino-project/core/i18n';
import { useGlobalComponentForModel } from '@rhino-project/core/hooks';
import { ModelBreadcrumb, ModelBreadcrumbProps } from './ModelBreadcrumb';

export type ModelCreateHeaderProps = ModelBreadcrumbProps;

export const ModelCreateHeaderBase = (props: ModelCreateHeaderProps) => {
  const { t } = useTranslation();
  return (
    <ModelBreadcrumb
      lastItem={t('rhino.frontend.messages.create')}
      {...props}
    />
  );
};

export const ModelCreateHeader = (props: ModelCreateHeaderProps) =>
  useGlobalComponentForModel('ModelCreateHeader', ModelCreateHeaderBase, props);
